import { useRegion } from '#hooks';
import { Head, LoadingContent } from '#components';
import { HeadUnderlineVariant } from '#components.types';
import RegionForm from './containers/RegionForm';
import { RegionFormInitialValues } from './containers/RegionForm/types';
import { RegionRestaurantsContainer } from './containers/Restaurants';

export default () => {
  const { data, loading, updateRegion } = useRegion();

  if (loading || !data) {
    return <LoadingContent />;
  }

  const handleSubmit = async (values: RegionFormInitialValues) => {
    await updateRegion(values);
  };

  return (
    <>
      <Head
        {...{
          label: `Регион ${data?.name}`,
          underlineVariant: HeadUnderlineVariant.Primary,
        }}
      />
      <RegionForm {...{ data, loading, onSubmit: handleSubmit }} />
      <RegionRestaurantsContainer regionId={data.id} />
    </>
  );
};
